/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHashtag: {
  name: 'hashtag';
  data: string;
} = {
  name: 'hashtag',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 3a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4h-4v4a1 1 0 1 1-2 0v-4H4a1 1 0 1 1 0-2h4v-4H4a1 1 0 0 1 0-2h4V4a1 1 0 0 1 2 0v4h4V4a1 1 0 0 1 1-1Zm-5 7v4h4v-4h-4Z" fill="currentColor"/></svg>`,
};
